
'use strict';//Indicating browser should run only in java script mode

angular.module('EMR.Admin').service('PatientDemographicsSettingsCommonService', ['$http', 'CommonService', 'CommonPostService', function ($http, CommonService, CommonPostService) {

    //################### METHOD TO  GET PATIENTS LTC LINKED FACILITIES LIST INFO  BLOCK START #########################
    /// ***PURPOSE: THIS METHOD IS USED TO GET PATIENTS LTC LINKED FACILITIES LIST INFO
    /// *******CREATED BY: RAVI CHANDRA TIRUNAGARI
    /// *******CREATED DATE:  05/16/2018
    /// *******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.PatientDemographicsGetPatientsLTCLinkedFacilitiesList = function (postData) {

        postData.practicemodel = EMRPracticeModel;
        postData.UserType = EMRPracticeModel.UserType;
        //  postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonService.PostData('POST', CommonService.EHR_LtcFacilities_API() + "GetPatientsLTCLinkedFacilitiesList", postData).then(
            function (result) {
                return result;
            });
    };
    //################### METHOD TO  GET PATIENTS LTC LINKED FACILITIES LIST INFO END #########################

    //################### GET PATIENT DEMOGRAPHICS BLOCK START#########################

    //*******PURPOSE: This method is used to get patient demographics settings
    //*******CREATED BY: Afroz
    //*******CREATED DATE: 07/20/2015
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.patientDemographicsSettingsGetSettings = function () {

        var postData = {};
        postData.practicemodel = EMRPracticeModel;

        return CommonService.PostData('POST', CommonService.EHR_Demographics_Settings() + "GetPatientDemographicsCustomizedSettings", postData).then(
            function (result) {
                return result;
            });

    };
    //################### SAVE PATIENT DEMOGRAPHICS BLOCK END #########################

    //################# TO GET DYNAMIC SEARCH PATIENT CONFIG INFO BLOCK START #################
    //********	This is to get dynamic search patient config info.
    //********	CREATED BY			: Swaraj B
    //********	CREATED DATE		: 04 Mar, 2019
    //********	MODIFIED DEVELOPER	: DATE - NAME - WHAT IS MODIFIED
    this.GetDynamicSearchPatientConfig = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonPostService.httpPostData('POST', `${CommonPostService.EHR_Demographics_SearchPatient()}GetDynamicSearchPatientConfig`, postData).then(
            function (result) {
                return result;
            });
    };
    //################# TO GET DYNAMIC SEARCH PATIENT CONFIG INFO BLOCK END #################

    /// ***PURPOSE: METHOD TO UPDATE GET OPEN CHART BUTTONS CUSTOMIZED AND NOT CUSTOMIZED LIST
    /// *******CREATED BY: AHMED BASHA SHAIK
    /// *******CREATED DATE: 10/12/2017
    /// *******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.PatientDemographicsSettingsServiceGetSearchPtButtonCustomiationList = function (postData) {

        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_SearchPatient_ColumnsAndButtonsCust_API() + "DemographicsGetCustomizedAndNotCustomizedButtonsList", postData).then(
            function (result) {
                return result;
            });
    };
    //################### SEARCH PATIENT CUSTOMIZATION DISPLAY SEQUENCE UPDATE BLOCK END #########################

    //################### GET DEMOGRAPHICS FIELDS CUSTOMIZATION INFO BLOCK START #########################
    //*******PURPOSE: THIS METHOD IS TO GET DEMOGRAPHICS FIELDS CUSTOMIZATION INFO
    //*******CREATED BY: kranthi kumar g
    //*******CREATED DATE: DEC 16 2015
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.getDemographicsCustomizedFieldsInfo = function (postData, callCenterSelectedPracticeModel) {


        postData.practicemodel = EMRPracticeModel;

        //###########CALL CENTER PRACTICE MODEL DATA PASSING BLOCK START#####################
        //IF CALL CENTER PRACTICE MODEL EXISTS THEN PASS THE CALL CENTER PRACTICE MODEL
        if (hasValue(callCenterSelectedPracticeModel))
            postData.practicemodel = callCenterSelectedPracticeModel;
        else //OTHERWISE PASS EXISTING EMRPRACTICE MODEL
            postData.practicemodel = EMRPracticeModel;
        //###########CALL CENTER PRACTICE MODEL DATA PASSING BLOCK END#####################

        return CommonService.PostData('POST', CommonService.EHR_Demographics_FieldsCustomization() + "getDemographicsCustomizedFieldsInfo", postData).then(
            function (result) {
                return result;
            });


        // COMMENTED ON 06/01/2018 TO IMPLEMEMNT LOCAL STORAGE START

        //postData.practicemodel = EMRPracticeModel;

        ////###########CALL CENTER PRACTICE MODEL DATA PASSING BLOCK START#####################
        ////IF CALL CENTER PRACTICE MODEL EXISTS THEN PASS THE CALL CENTER PRACTICE MODEL
        //if (hasValue(callCenterSelectedPracticeModel))
        //    postData.practicemodel = callCenterSelectedPracticeModel;
        //else //OTHERWISE PASS EXISTING EMRPRACTICE MODEL
        //    postData.practicemodel = EMRPracticeModel;
        ////###########CALL CENTER PRACTICE MODEL DATA PASSING BLOCK END#####################

        //return CommonService.PostData('POST', CommonService.EMRPracticeManagement() + "getDemographicsCustomizedFieldsInfo", postData).then(
        //function (result) {
        //    return result;
        //});
        // COMMENTED ON 06/01/2018 TO IMPLEMEMNT LOCAL STORAGE END

        //if (hasValue(postData) && hasValue(postData.DemographicFiledCustomizationModuleType) && parseInt(postData.DemographicFiledCustomizationModuleType) > 0
        //    && parseInt(postData.DemographicFiledCustomizationModuleType) == 2) {

        //    postData.practicemodel = EMRPracticeModel;

        //    //###########CALL CENTER PRACTICE MODEL DATA PASSING BLOCK START#####################
        //    //IF CALL CENTER PRACTICE MODEL EXISTS THEN PASS THE CALL CENTER PRACTICE MODEL
        //    if (hasValue(callCenterSelectedPracticeModel))
        //        postData.practicemodel = callCenterSelectedPracticeModel;
        //    else //OTHERWISE PASS EXISTING EMRPRACTICE MODEL
        //        postData.practicemodel = EMRPracticeModel;
        //    //###########CALL CENTER PRACTICE MODEL DATA PASSING BLOCK END#####################

        //    return CommonService.PostData('POST', CommonService.EMRPracticeManagement() + "getDemographicsCustomizedFieldsInfo", postData).then(
        //    function (result) {
        //        return result;
        //    });

        //}
        //else {

        //    var PatientDemographicsSettingsServiceInstance = this;

        //    var deferred = $q.defer();

        //    //CHECKING WHETHER THE SELECTED DATA IS PRESENT IN LLS OR NOT
        //    LocalStorageFactory.GetContentInEHRLocalStorage("demographicsDetailedFieldsList^" + EMRPracticeModel.PracticeID).then(function (serviceResponse) {

        //        if (isError(serviceResponse) || !LocalStorageFactory.hasValueInLLS(serviceResponse)) {

        //            //REQUESTED DEMOGRAPHICS FIELDS IS NOT IN LLS, SO WE ARE GETTING COUNTY LIST FROM DB AND ADDING TO LLS

        //            console.log('Getting Detailed Demographics Fields from - DATABASE');
        //            //GET DEMOGRAPHICS FIELDS FROM DB
        //            //ADD DEMOGRAPHICS FIELDS VERSION TO LLS
        //            PatientDemographicsSettingsServiceInstance.getDemographicsCustomizedFieldsInfoServiceForLLS(postData).then(function (result) {
        //                deferred.resolve(result);
        //            });
        //        }
        //        else {
        //            //==========       REQUESTED COUNTY LIST IS PRESENT IN LLS, SO GETTING FROM LLS        ====================

        //            console.log('Getting Detailed Demographics Fields - LOCAL STORAGE');
        //            //THIS INDICTES COUNTY LIST IN LLS IS LATEST, NO NEED TO UPDATE
        //            deferred.resolve(serviceResponse);


        //        }
        //    });

        //    return deferred.promise;


        //}


    };

    //################### FOR GETTING THE WHETHER THE USER PATIENTS LIST IS CD OR NOT STARTS  #################//
    /**
    *@function getUserPatientLisIsCustomizedOrNot
    * @description THIS FUNCTION IS USED TO GET FLAG IsPatientsLinkedToLoggedUser WHETHER THE USER IS CUSTOMIZED WITH PATIENTS OR NOT
    * @since 01022021
    */
    this.getUserPatientLisIsCustomizedOrNot = function (inputDataTogetUserPatientLisIsCustomizedOrNot) {
        inputDataTogetUserPatientLisIsCustomizedOrNot.practicemodel = EMRPracticeModel;
        return CommonService.PostData('POST', CommonService.EHR_PatientChart_Open_Permissions_API() + "IsPatientsLinkedToLoggedUser", inputDataTogetUserPatientLisIsCustomizedOrNot).then(function (result) {
            return result;
        });
    };
    //################### FOR GETTING THE WHETHER THE USER PATIENTS LIST IS CUSTOMIZED OR NOT ENDS  #################//

    //################### GET DEMOGRAPHICS FIELDS CUSTOMIZATION INFO BLOCK END #########################
}]);